import { SuccessResponse } from 'shared/api/auth/auth.types'
import { User, UserRole } from 'shared/types/user'

export interface CheckTokenRequest {
  token: string
}

export type CheckTokenResponse = SuccessResponse<{
  iss: string
  iat: number
  exp: number
  nbf: number
  jti: string
  sub: number
  prv: string
  user_agent: string
  original_organization_id?: number | null
  user: User
  employee: unknown | null
  permissions: string[]
  roles: UserRole[]
  partner_nodes: Record<string, number[]>
}>
